import React from "react";
import { Box, Typography } from "@mui/material";

export interface OsToggleProps {
  value: "ios" | "android";
  onChange: (value: "ios" | "android") => void;
}

const OPTIONS: { key: "ios" | "android"; label: string }[] = [
  { key: "ios", label: "iOS" },
  { key: "android", label: "Android" },
];

/**
 * Plain @mui/material primitives only, so it renders under either app's
 * ThemeProvider.
 */
function OsToggle(props: OsToggleProps) {
  const { value, onChange } = props;

  return (
    <Box
      role="tablist"
      aria-label="Preview device"
      sx={(theme) => ({
        display: "inline-flex",
        padding: "3px",
        gap: "2px",
        borderRadius: 9999,
        backgroundColor: theme.palette.action.hover,
      })}
    >
      {OPTIONS.map((option) => {
        const active = value === option.key;
        return (
          <Box
            key={option.key}
            component="button"
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(option.key)}
            sx={(theme) => ({
              border: "none",
              cursor: "pointer",
              padding: "6px 18px",
              borderRadius: 9999,
              backgroundColor: active
                ? theme.palette.common.white
                : "transparent",
              boxShadow: active ? "0 1px 2px rgba(19, 10, 46, 0.12)" : "none",
            })}
          >
            <Typography
              variant="caption"
              sx={(theme) => ({
                color: active
                  ? theme.palette.text.primary
                  : theme.palette.text.secondary,
                fontWeight: active ? 700 : 400,
              })}
            >
              {option.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

export default OsToggle;
